import { ErrorMessages } from "consts";
import { formatStringTemplate } from "@civicscience/chops";

const { ErrDecimalPoints } = ErrorMessages;

export const validateMaxDecimalPoints = (value: number, decimalPoints: number): boolean | string => {
  const decimalPart = value.toString().split(".")[1];
  return (
    !decimalPart || decimalPart.length <= decimalPoints || formatStringTemplate(ErrDecimalPoints, { decimalPoints })
  );
};
